module.exports = __webpack_public_path__ + "static/media/instruction-sampleBtn.326a1453.gif";